
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Barlow, sans-serif', color: '#047481' }}>
              Stiletto Airpark
            </h3>
            <p className="text-gray-300 mb-4">
              Professional <strong>flight training</strong> facility offering comprehensive aviation education in a relaxed, friendly environment.
            </p>
            <div className="text-gray-300">
              <p className="mb-2">
                <i className="ri-map-pin-line mr-2"></i>
                Stiletto Airpark (XS79)
              </p>
              <p className="mb-2">8834 E FM 243, Bertram, TX 78605</p>
            </div>
          </div>

          {/* Training Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Training Services</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a href="/training/tailwheel-endorsement" className="hover:text-teal-400 transition-colors cursor-pointer">
                  <strong>Tailwheel Endorsement</strong>
                </a>
              </li>
              <li>
                <a href="/training/sport-pilot" className="hover:text-teal-400 transition-colors cursor-pointer">
                  <strong>Sport Pilot License</strong>
                </a>
              </li>
              <li>
                <a href="/training/private-pilot" className="hover:text-teal-400 transition-colors cursor-pointer">
                  <strong>Private Pilot License</strong>
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Information</h4>
            <div className="space-y-3 text-gray-300">
              <div>
                <p className="font-medium">Email:</p>
                <a href="mailto:stiletto1@stilettoaircraft.com" className="text-teal-400 hover:text-teal-300 cursor-pointer">
                  stiletto1@stilettoaircraft.com
                </a>
              </div>
              <div>
                <p className="font-medium">Airpark Info/Visits:</p>
                <a href="tel:512-635-0847" className="text-teal-400 hover:text-teal-300 cursor-pointer">
                  Call/Text: 512-635-0847
                </a>
              </div>
              <div>
                <p className="font-medium">Flight Training:</p>
                <a href="tel:706-936-8961" className="text-teal-400 hover:text-teal-300 cursor-pointer">
                  Bryson Agee: 706-936-8961
                </a>
                <br />
                <a href="tel:512-658-3132" className="text-teal-400 hover:text-teal-300 cursor-pointer">
                  Scott Wallace: 512-658-3132
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Service Areas */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="text-center">
            <p className="text-gray-400 mb-2">Serving The Central Texas Aviation Community</p>
            <p className="text-sm text-gray-500">
              Austin • Bertram • Round Rock • Cedar Park • Leander • Temple • Killeen • San Marcos • DFW • Houston • Denton • Frisco
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 <span className="text-teal-400">Stiletto Airpark</span>. All rights reserved.
            {' '}
            <a href="https://readdy.ai/?origin=logo" className="text-gray-500 hover:text-gray-400 transition-colors">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
